import React, { createContext, useContext, useMemo } from 'react';
import useMedia from 'use-media';

export interface MediaQueryContextValue {
  columns: 1 | 2 | 3;
}

export const MediaQueryContext = createContext<MediaQueryContextValue>({ columns: 1 });

const mediaQueries = {
  twoColumn: '(min-width: 40rem)',
  threeColumn: '(min-width: 70rem)',
  prefersReducedMotion: '(prefers-reduced-motion: reduce)',
};

export function MediaQueryContextProvider({
  children,
  override,
}: React.PropsWithChildren<{ override?: Partial<MediaQueryContextValue> }>) {
  const twoColumn = useMedia(mediaQueries.twoColumn);
  const threeColumn = useMedia(mediaQueries.threeColumn);
  const columns: 1 | 2 | 3 =
    threeColumn ? 3
    : twoColumn ? 2
    : 1;
  const value = useMemo(() => ({ columns, ...override }), [columns, override]);

  return <MediaQueryContext.Provider value={value}>{children}</MediaQueryContext.Provider>;
}

export function useMediaQueryContext() {
  return useContext(MediaQueryContext);
}
